import {
  WISHLIST_CHANGE_QUANTITY,
  WISHLIST_UPDATE,
  WISHLIST_ADD_TO_CART,
  WISHLIST_GET_LISTS,
  WISHLIST_SET_SELECTED,
  WISHLIST_REMOVE_LISTITEM,
  WISHLIST_REMOVE_LIST,
} from '../Services/WishList.service';

export const wishLists = (state = {}, action) => {
  switch (action.type) {
    case WISHLIST_CHANGE_QUANTITY:
      return {
        ...state,
        lists: state.lists.map((e) => {
          if (e.name == action.name) {
            return {
              ...e,
              items: e.items.map((wish) =>
                wish.articleNumber === action.articleNumber
                  ? { ...wish, quantity: action.quantity }
                  : wish
              ),
            };
          } else {
            return e;
          }
        }),
      };
    case WISHLIST_UPDATE:
    case WISHLIST_SET_SELECTED:
    case WISHLIST_ADD_TO_CART:
      return {
        ...state,
        payload: action.payload,
      };

    case WISHLIST_GET_LISTS:
      return {
        ...state,
        payload: {
          ...action.payload,
          ...(state?.payload?.selected && { selected: state.payload.selected }),
        },
      };
    case WISHLIST_REMOVE_LIST:
      return {
        ...state,
        lists: state.lists.filter((i) => i.name != action.payload.listName),
        payload: action.payload,
      };
    case WISHLIST_REMOVE_LISTITEM:
      return {
        ...state,
        lists: state.lists.map((i) => {
          if (i.name == action.payload.listName) {
            return { ...i, items: action.payload.items };
          } else return i;
        }),
      };
    default:
      return state;
  }
};
